export const buildInstanceSelectListInput = ({
  instance,
  ids = [],
  select,
  search,
  images = false,
  primary = false,
}) => {
  if (instance?.id && images) {
    const artworkId = instance.artworkId || instance.edition?.artwork?.id;
    const artworkImages = instance.edition?.artwork?.images || [];
    const selectedImages = primary ? artworkImages.slice(0, 1) : artworkImages;
    const listItemIds = selectedImages
      .filter(image => image?.archiveId && artworkId)
      .map(image => `${image.archiveId},${artworkId}`);
    return listItemIds.length ? { listItemIds } : null;
  }

  const selectedIds = instance?.id ? [instance.id] : ids.filter(Boolean);
  if (!selectedIds.length) return null;

  if (!instance?.id && select === "all" && search) {
    return { search };
  }

  // Image-list rows carry instance references; ordinary rows carry numeric IDs.
  const hasNumericIds = selectedIds.every(id => Number.isInteger(Number(id)));
  if (images || !hasNumericIds) {
    return {
      search: {
        [hasNumericIds ? "id" : "name"]: {
          operator: "in",
          value: selectedIds,
        },
        limit: selectedIds.length,
        offset: 0,
      },
    };
  }

  return { listItemIds: selectedIds };
};
